"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var styles = function styles(theme) {
  return {
    root: {
      boxSizing: 'border-box',
      width: '100%',
      maxWidth: '100%',
      padding: theme.spacing.unit * 2.2,
      background: theme.palette.bottomDialogBackground
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing.unit * 1.2,
      top: theme.spacing.unit * 1.2,
      width: 50,
      color: theme.palette.primary.contrastText
    },
    primaryButton: {
      display: 'block',
      marginTop: theme.spacing.unit * 2
    },
    description: {
      marginRight: theme.spacing.unit * 1.5,
      color: theme.palette.primary.contrastText,
      maxHeight: 75,
      overflow: 'auto'
    },
    header: {
      color: theme.palette.primary.contrastText,
      textTransform: 'capitalize'
    }
  };
};

var DEFAULT_ACKNOWLEDGMENT_TITLE = 'Acknowledgement of Receipt';
var DEFAULT_ACKNOWLEDGMENT_DESCRIPTION = 'I acknowledge receipt of, and agree to read and adhere to, the policies and procedures outlined in the document.';

var ClickThroughAcknowledgment = /*#__PURE__*/function (_Component) {
  _inherits(ClickThroughAcknowledgment, _Component);

  function ClickThroughAcknowledgment() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ClickThroughAcknowledgment);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ClickThroughAcknowledgment)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      checked: false
    });

    _defineProperty(_assertThisInitialized(_this), "onCheck", function (_ref) {
      var checked = _ref.target.checked;
      return _this.setState({
        checked: checked
      });
    });

    return _this;
  }

  _createClass(ClickThroughAcknowledgment, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          isOpen = _this$props.isOpen,
          title = _this$props.title,
          description = _this$props.description,
          onAcknowledge = _this$props.onAcknowledge,
          onClose = _this$props.onClose;
      var checked = this.state.checked;
      return _react.default.createElement(_core.Drawer, {
        open: isOpen,
        anchor: "bottom"
      }, _react.default.createElement("div", {
        className: classes.root
      }, _react.default.createElement(_core.Typography, {
        variant: "h5",
        gutterBottom: true,
        className: classes.header,
        "data-test-id": "ClickThroughAcknowledgment-header"
      }, title || DEFAULT_ACKNOWLEDGMENT_TITLE), _react.default.createElement(_core.Button, {
        className: classes.closeButton,
        onClick: onClose,
        tabIndex: "-1",
        "data-test-id": "ClickThroughAcknowledgment-closeButton"
      }, _react.default.createElement(_icons.Close, null)), _react.default.createElement(_core.Typography, {
        component: "p",
        className: classes.description
      }, _react.default.createElement(_core.Checkbox, {
        onChange: this.onCheck,
        "data-test-id": "ClickThroughAcknowledgment-checkbox"
      }), ' ', description || DEFAULT_ACKNOWLEDGMENT_DESCRIPTION), _react.default.createElement(_core.Button, {
        color: "primary",
        variant: "contained",
        className: classes.primaryButton,
        onClick: onAcknowledge,
        disabled: !checked,
        "data-test-id": "ClickThroughAcknowledgment-submitButton"
      }, "Submit Acknowledgment")));
    }
  }]);

  return ClickThroughAcknowledgment;
}(_react.Component);

var _default = (0, _styles.withStyles)(styles)(ClickThroughAcknowledgment);

exports.default = _default;